import React from 'react';
import ServicesReport from '../../../components/ServicesReport/index';

function ServicesReportPage() {
  return <ServicesReport />;
}

export default ServicesReportPage;
